<template>
	<button
		v-if="isMobile"
		:aria-label="label"
		class="toggle"
		@click="toggle()"
	>
		{{ label }}
		<FaIcon
			:icon="['fa-solid', 'fa-chevron-down']"
			class="toggle__icon"
			:class="{ 'toggle__icon--open': isOpen }"
		/>
	</button>
</template>

<script lang="ts" setup>
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import { computed, ref } from 'vue';
import { useStore } from '@store/index';
import { useTranslations } from '@helper/composables/translations';
const store = useStore();

const { translate } = useTranslations();

const props = defineProps<{
	labelMore?: string;
	labelLess?: string;
}>();

const label = computed(() => {
	const labelOpen = props.labelMore ?? translate('showMoreToggle.more');
	const labelClose = props.labelLess ?? translate('showMoreToggle.less');
	return isOpen.value ? labelClose : labelOpen;
});

const isMobile = computed(() => !store.state.config.isMinTablet);

const emit = defineEmits(['ShowMoreToggle:onToggle']);
const isOpen = ref(false);
const toggle = () => {
	emit('ShowMoreToggle:onToggle', !isOpen.value);
	isOpen.value = !isOpen.value;
};
</script>

<style lang="scss" scoped>
.toggle {
	margin-top: 0.8rem;
	text-align: right;
	font-size: $font-small-2;
	color: $color-primary;
	line-height: 2.6rem;
	width: 100%;
	background: none;
	border: none;
	outline: inherit;

	&__icon {
		&--open {
			transform: rotate(180deg);
		}
	}
}
</style>
